import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

export const exportToExcel = (data, fileName) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const columnWidths = [];
  const keys = Object.keys(data[0]);
  keys?.forEach((key, colIndex) => {
    let maxLength = key.length;
    data?.forEach((row) => {
      maxLength = Math.max(
        maxLength,
        row[key] ? row[key].toString().length : 0
      );
    });
    columnWidths[colIndex] = { wch: maxLength + 2 };
  });

  worksheet["!cols"] = columnWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${fileName}.xlsx`);
};
export const exportToExcelTPMsummary = async (data, fileName) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("TPM Summary");

  // 🟢 Define heading colors
  const headingColors = ["AA1A5F"]; // Dark pink, blue, green, orange, purple

  // 🟢 Style for titles
  const getTitleStyle = (color) => ({
    font: { bold: true, color: { argb: "FFFFFFFF" } }, // White text
    fill: { type: "pattern", pattern: "solid", fgColor: { argb: color } }, // Dynamic background color
    alignment: { horizontal: "center", vertical: "middle" },
    border: {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    },
  });

  // 🟢 Style for normal table cells
  const cellStyle = {
    border: {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    },
  };

  // Insert data into worksheet
  let headingIndex = 0;
  data.forEach((row, rowIndex) => {
    const sheetRow = worksheet.addRow(row);
    sheetRow.eachCell((cell, colIndex) => {
      if (rowIndex === 0 || row.length === 1) {
        // Apply different colors to each heading
        cell.style = getTitleStyle(headingColors[headingIndex % headingColors.length]);
        headingIndex++;
      } else {
        cell.style = cellStyle;
      }
    });
  });

  // Auto-adjust column width
  worksheet.columns.forEach((col, colIndex) => {
    let maxLength = 0;
    worksheet.eachRow((row) => {
      const cellValue = row.getCell(colIndex + 1).value;
      const cellText = cellValue ? cellValue.toString() : "";
      maxLength = Math.max(maxLength, cellText.length);
    });
    col.width = maxLength + 2; // Add padding for better spacing
  });
  // Generate the Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Trigger download
  saveAs(blob, `${fileName}.xlsx`);
};
